import categories from './categories'

export default {
    namespaced: true,
    state: {
        item: null,
        carousels: null,
        collections: null
    },
    getters: {
        item: state => state.item,
        carousels: state => state.carousels,
        collections: state => state.collections
    },
    mutations: {
        SET_ITEM(state, item) {
            state.item = item
        },
        SET_CAROUSELS(state, items) {
            state.carousels = items
        },
        SET_COLLECTIONS(state, items) {
            state.collections = items
        }
    },
    actions: {
        async getItem({ commit }, brandId) {
            const resp = await this.$axios.get(`/public/brand-page/${brandId}`)

            commit('SET_ITEM', resp.data.brand_page)
        },
        async getCarousels({ commit }, brandId) {
            const resp = await this.$axios.get(
                `/public/brand-page/${brandId}/carousels`
            )

            commit('SET_CAROUSELS', resp.data.brand_page_carousels)
        },
        async getCollections({ commit }, brandId) {
            const resp = await this.$axios.get(
                `/public/brand-page/${brandId}/collections`
            )

            commit('SET_COLLECTIONS', resp.data.product_collections)
        }
    },
    modules: {
        categories
    }
}
